import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {
  loadingCounter = signal(0);

  isLoading = computed(() => this.loadingCounter() > 0);

  startLoading() { this.loadingCounter.update(c => c + 1); }
  stopLoading() { this.loadingCounter.update(c => c - 1); }
}
